import "@/App.css";
import { Toaster } from "sonner";
import { LangProvider } from "@/context/LangContext";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/pakla/Navbar";
import Hero from "@/components/pakla/Hero";
import EditorialMarquee from "@/components/pakla/Marquee";
import HowToUse from "@/components/pakla/HowToUse";
import Products from "@/components/pakla/Products";
import Ingredients from "@/components/pakla/Ingredients";
import Testimonials from "@/components/pakla/Testimonials";
import FAQ from "@/components/pakla/FAQ";
import LabReport from "@/components/pakla/LabReport";
import News from "@/components/pakla/News";
import Contact from "@/components/pakla/Contact";
import Footer from "@/components/pakla/Footer";
import VisitorCounter from "@/components/pakla/VisitorCounter";

const PageShell = () => {
  useLenis();
  return (
    <div className="App relative" data-testid="app-shell">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <HowToUse />
        <Products />
        <Ingredients />
        <Testimonials />
        <LabReport />
        <FAQ />
        <News />
        <Contact />
      </main>
      <Footer />
      <VisitorCounter />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F3D2E",
            color: "#FAF7F0",
            border: "1px solid #2E8B4A",
            borderRadius: "12px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <LangProvider>
      <PageShell />
    </LangProvider>
  );
}

export default App;
